import * as React from "react";
import ShiftCategoryList from "../../presentations/ShiftCategoryList";

const ShiftCategoryListContainer = (props: any) => {

  const {onEdit} = props;

  const handleOnEdit = (rowData: any) => {
    onEdit(rowData);
  }

  return (
    <div>
      <ShiftCategoryList onEdit={handleOnEdit}></ShiftCategoryList>
    </div>
  );
};

export default ShiftCategoryListContainer;
